<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                disable-permission-checks
                :go-to-add-on-click="false"
                :goToDetailsOnRowClick="false"
                @on-add="onAddClick"
                @on-row-click="onRowClick"
                rowNavigationKey="user_uuid"
                rowDeleteKey="uuid"
                operations="delete,refresh,add"
                ref="table">
      <template v-slot:name="{row}">
        <div class="flex items-center">
          <base-avatar :user="row"
                       :src="row.image">
          </base-avatar>
          <div class="ml-2 font-bold">
            {{row.given_name}} {{row.last_name}}
          </div>
        </div>
      </template>

      <template v-slot:email="{row}">
        {{row.email}}
      </template>
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:active="{row}">
        <base-switch :value="row.active" @input="onToggleClientStatus(row, $event)"/>
      </template>
    </data-table>
  </div>
</template>
<script>
  import ClientUserService from 'src/services/ClientUserService'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'client-management-users',
    data () {
      return {
        FRIENDLY_DATETIME_FORMAT,
        entity: entities.CLIENT_USER,
        service: ClientUserService,
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('user.list.labels.name'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'email',
            label: this.$t('user.list.labels.email'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '170px',
            sortable: true,
            mobile: false
          },
          {
            prop: 'active',
            label: this.$t('generic.active'),
            minWidth: '170px',
            sortable: true,
            mobile: true
          }
        ]
      },
      filters () {
        return [
          {
            key: 'match[client_uuid]',
            value: this.$route.params.id
          }
        ]
      }
    },
    methods: {
      onAddClick () {
        this.$router.push({path: '/contacts/users/create', query: {client_uuid: this.$route.params.id}})
      },
      onRowClick (row) {
        this.$router.push({path: `/contacts/users/${row.user_uuid}`})
      },
      async onToggleClientStatus(row, active) {
        const prevValue = row.active
        try {
          this.$set(row, 'active', active)
          await ClientUserService.update(row.uuid, row)
        } catch (err) {
          this.$set(row, 'active', prevValue)
        }
      }
    }
  }
</script>
<style>
</style>
